// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2nhc8","clinicsSelect":"TableHeading_clinicsSelect__AUWTR"};